module.exports = __webpack_public_path__ + "img/icon-questions-not-ranking.cab9ab18.svg";